import {Component, Input, OnInit} from '@angular/core';

import { ROOT_ORGS } from '../capd-admin-component/capd-admin.component';
import { CDSNode, Rule, Org } from '../services/capd.model';
import { OrgService } from '../services/org.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'user-config',
  templateUrl: './user-config.component.html',
  // inputs: ['org','user']
})

/**
 * Component for configuring individual rules for a user.
 */
export class UserConfigComponent {

  @Input() org: CDSNode;
  @Input() user: CDSNode;
  userRules: Rule[];
  ruleEdits: Rule[] = [];
  watermarkText: String;

  constructor(private _user: UserService,
              private _settings: OrgService) {
  }

  ngOnInit() {
    this.userRules = null;
    this.watermarkText = '<span>Loading...<br /><img src="./app/css/img/linear-loader.gif" alt="" /></span>';

    if(!!this.org && !!this.user) {
      // get settings
      let rootId = '';
      let i = 2;
      do{
        rootId = this.org.rootId.split('.', i).join('.');
        i++;
      }while (ROOT_ORGS.indexOf(rootId) >= 0);

      // get the rules
      //@ts-ignore
      this._user.getUserRules(rootId, this.user.rootId, this.user.groupShortOids).then((rules: Rule[]) => {
        this.userRules = rules.sort((a, b) => {
          const test1 = a.contentPackage_id.localeCompare(b.contentPackage_id);
          if (test1 !== 0) { return test1; }
          else { return a.triggerName.localeCompare(b.triggerName); }
        });
        this.watermarkText = '<span>There are no rules to display for this user.</span>';
      });
    } else {
      this.watermarkText = '<span>There are no rules to display for this user.</span>';
    }


  }

  /**
   * When the user is changed, call this function again to load the new rules.
   *
   * @async
   * @func ngOnChanges
   */
  OnChanges() {
    this.userRules = null;
    this.watermarkText = '<span>Loading...<br /><img src="../css/img/linear-loader.gif" alt="" /></span>';
    if (!!this.org && !!this.user) {
      // get settings
      let rootId = '';
      let i = 2;
      do{
        rootId = this.org.rootId.split('.', i).join('.');
        i++;
      }while (ROOT_ORGS.indexOf(rootId) >= 0);
      // get the rules
      //@ts-ignore
      this._user.getUserRules(rootId, this.user.rootId, this.user.groupShortOids).then((rules: Rule[]) => {
        this.userRules = rules.sort((a, b) => {
          const test1 = a.contentPackage_id.localeCompare(b.contentPackage_id);
          if (test1 !== 0) { return test1; }
          else { return a.triggerName.localeCompare(b.triggerName); }
        });
        this.watermarkText = '<span>There are no rules to display for this user.</span>';
      });
    }
  }

  /**
   * Checks if the user has a personal override on the rule state.
   * If so, return that; otherwise, return the setting of that rule for the group.
   *
   * @func getRuleState
   * @param {Rule} rule - the rule whose state is being checked.
   * @returns "Enabled," "Silent" or "Disabled," depending on the rule's state.
   */
  getRuleState(rule: Rule): string {
    if (!rule.state && !rule.uState) {
      return 'Enabled';
    }
    else if (!!rule.uState) {
      return rule.uState;
    }
    else {
      return rule.state;
    }
  }

  /**
   * Adds or removes a rule from the list of rules to edit.
   *
   * @func onSelect
   * @param {Rule} rule - the rule to add or remove.
   */
  onSelect(rule: Rule) {
    const index = this.ruleEdits.indexOf(rule);
    if (index < 0) {
      this.ruleEdits.push(rule);
    }
    else {
      this.ruleEdits.splice(index, 1);
    }
  }

  /**
   * Uses the checkbox on the header to select/deselect all rules automatically.
   *
   * @func onHeaderSelect
   */
  onHeaderSelect() {
    if (this.ruleEdits.length >= this.userRules.length) {
      this.ruleEdits.splice(0, this.ruleEdits.length);
    }
    else {
      this.userRules.forEach(rule => this.addAll(rule));
    }
  }

  /**
   * Adds all rules not currently selected, one by one.
   *
   * @func addAll
   * @param {Rule} rule - the current rule being added.
   */
  addAll(rule: Rule) {
    const index = this.ruleEdits.indexOf(rule);
    if (index < 0 && (!rule.state || rule.state === 'Enabled')) {
      this.ruleEdits.push(rule);
    }
  }

  /**
   * Submits changes to the server.
   *
   * @async
   * @func onSubmit
   * @param {string} newState - the new state to apply to the rules.
   */
  onSubmit(newState: string) {
    this.ruleEdits.forEach(rule => rule.uState = newState);
    this._user.updateUserRules(this.org.rootId, this.user.rootId, this.ruleEdits).then(() => this.ruleEdits = []);
  }
}
